import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/league/settle/record/list',
      data
    });
  },
  transaction(data) {
    return http.post({
      url: '/la/admin/league/settle/transaction',
      data,
      dataType: 'form'
    });
  },
  transactionSwitch(data) {
    return http.post({
      url: '/la/admin/league/settle/switch/toggle',
      data,
      dataType: 'form'
    });
  },
  getTransactionSwitch(data) {
    return http.get({
      url: '/la/admin/league/settle/switch/get',
      data
    });
  }
};
